import { Engine } from '../../core/Engine';
import { CloneCommand } from '../Commands';
import { Cloner } from '../../core/Cloner';
import { GraphicElement } from '../../entities/Drawable/GraphicElement';
import { Vector } from '../../entities/Vector';

export class CloneCommandHandler {
    engine: Engine;

    constructor(engine: Engine) {
        this.engine = engine;
    }

    handle(command: CloneCommand) {
        const obj: GraphicElement = this.engine.find(command.uuid);
        const clone: GraphicElement = Cloner.execute(obj);
        clone.uuid = GraphicElement.generateUUID();
        this.engine.content.push(clone);
        clone.transform.move(new Vector(50 / this.engine.canvas.width, 50 / this.engine.canvas.width));
        this.engine.selectedElement = clone;
    }
}
